import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DashboardForm_04 = () => {
  const classes = useStyles();

  const { selected_profile, profile_fb_details, selected_fb_details } =
    useContext(FacebookProfilesDashboardContext);

  return (
    // 4th Column
    <Grid item xs={3} container direction="column" spacing={1}>
      {" "}
      {/* Quick Functions
                  <Grid item className={classes.title}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      Quick Functions
                    </Typography>
                  </Grid> */}{" "}
      {/* Buttons */}{" "}
      {/* <Grid item container spacing={1}>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                      >
                        Create Warm Campaign
                      </Button>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                      >
                        Create Phase 1 Campaign
                      </Button>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                      >
                        Create Phase 2 Campaign
                      </Button>
                    </Grid>
                  </Grid> */}{" "}
    </Grid>
  );
};

export default DashboardForm_04;
